var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "uk-margin-medium-bottom",
    attrs: {
      "uk-tab": ""
    }
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.displayed('product-families')
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.productFamiliesActiveRevisions')) + ": " + _vm._s(_vm.activeRevisions['product_families']))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.displayed('products')
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.productsActiveRevisions')) + ": " + _vm._s(_vm.activeRevisions['products']))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.displayed('offers')
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.offersActiveRevisions')) + ": " + _vm._s(_vm.activeRevisions['offers']))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.displayed('contracts')
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.contractsActiveRevisions')) + ": " + _vm._s(_vm.activeRevisions['contracts']))])])]), _vm._v(" "), _c('div', [_c('ProductFamiliesActiveRevisionsIndexView', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplayed == 'product-families'),
      expression: "isDisplayed == 'product-families'"
    }],
    on: {
      "update-active-revisions": _vm.updateActiveRevisions
    }
  }), _vm._v(" "), _c('ProductsActiveRevisionsIndexView', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplayed == 'products'),
      expression: "isDisplayed == 'products'"
    }],
    on: {
      "update-active-revisions": _vm.updateActiveRevisions
    }
  }), _vm._v(" "), _c('OffersActiveRevisionsIndexView', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplayed == 'offers'),
      expression: "isDisplayed == 'offers'"
    }],
    on: {
      "update-active-revisions": _vm.updateActiveRevisions
    }
  }), _vm._v(" "), _c('ContractsActiveRevisionsIndexView', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplayed == 'contracts'),
      expression: "isDisplayed == 'contracts'"
    }],
    on: {
      "update-active-revisions": _vm.updateActiveRevisions
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fe8e17b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/ActiveRevisions/ActiveRevisionsView.vue
// module id = 1921
// module chunks = 0